import './styles/Paywall.scss';
import ComboCard from './scripts/paywall/components/comboCard';
import PaywallAnimations from './scripts/paywall/animations/paywallAnimations';
import FloatingCards from './scripts/paywall/animations/floatingCards';
import { model } from './scripts/paywall/core/model';
import Router from './scripts/paywall/controllers/router';
import { Config } from './scripts/paywall/core/config';
import Datadog from './scripts/common/datadog'
import { updateFavicon } from "./scripts/paywall/views/favicon";
import loggedin from './scripts/paywall/controllers/loggedIn'
import libs from './scripts/paywall/libs/index'
import Analitycs from './scripts/paywall/helpers/analytics'
import BannerFamiliar from './scripts/paywall/components/bannerFamiliar'
import Remaining from './scripts/paywall/components/remaining';
import CustomDimension from './scripts/paywall/helpers/customDimension'
import abTesting from './scripts/paywall/helpers/abTesting';
import { UCL } from './scripts/paywall/core/UserClientLibs';
import ButtonTracker from './scripts/paywall/helpers/buttonTracker';
import { initMostrarError } from './scripts/paywall/controllers/error';

const start = async () => {
    initMostrarError();
    FloatingCards.init();
    window.LN = window.LN || {};
    window.LN.Model = model;
    window.LN.Config = Config;
    libs();
    await UCL.GetAccessTokenValidatedAsync();
    UCL.GoogleOneTap();
    loggedin();
    Router.init();
    updateFavicon();
    ComboCard.init();
    PaywallAnimations.init();
    BannerFamiliar.init();
    CustomDimension();
    Datadog.setUserContext();
    Remaining.init();
    abTesting.chooseVariant();
    Analitycs.pushDelayed();
    ButtonTracker.init()
};

start();



// WEBPACK FOOTER //
// ./Statics/paywall.js